import { certifications } from "api/certified-api";

/**
 * Genera los encabezados comunes para las peticiones.
 * @param {string} token - Token JWT.
 * @returns {Object} Headers estándar.
 */
const getHeaders = (token) => ({
	'Content-Type': 'application/json',
	'Accept': 'application/json',
	'x-access-token': token
});

/**
 * Obtiene todas las preguntas EMeT.
 */
export const fetchAllQuestions = async (token) => {
	const response = await certifications.get(`/emet/questions`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene las preguntas por sección.
 */
export const fetchQuestionsSectionById = async (id, token) => {
	const response = await certifications.get(`/emet/questions/section/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene todas las preguntas con respuestas por sección.
 */
export const fetchQuestionsAnswersBySectionId = async (id, token) => {
	const response = await certifications.get(`/emet/questions/answers/section/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene respuestas por ID de pregunta.
 */
export const fetchAnwersQuestionById = async (id, token) => {
	const response = await certifications.get(`/emet/answers/question/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene la última pregunta registrada.
 */
export const fetchLastQuestionEmet = async (token) => {
	const response = await certifications.get(`/emet/last/question`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene todas las preguntas con sus respuestas.
 */
export const fetchQuestionsAnswers = async (token) => {
	const response = await certifications.get(`/emet/questions/answers`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene una pregunta con sus respuestas por ID.
 */
export const fetchQuestionAnswersById = async (id, token) => {
	const response = await certifications.get(`/emet/questions/answers/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Crea una nueva pregunta EMeT.
 */
export const createQuestionEmet = async (data, token) => {
	const response = await certifications.post(`/emet/question`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Crea una hoja de puntuación EMeT.
 */
export const createScoreSheetEmet = async (data, token) => {
	const response = await certifications.post(`/emet/score/sheet`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Crea varias preguntas EMeT.
 */
export const createQuestionsEmet = async (data, token) => {
	const response = await certifications.post(`/emet/questions`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Crea una nueva respuesta EMeT.
 */
export const createAnswerEmet = async (data, token) => {
	const response = await certifications.post(`/emet/answers`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Actualiza una pregunta EMeT por su ID.
 */
export const updateEmetQuestionById = async (id, data, token) => {
	const response = await certifications.put(`/emet/questions/${id}`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Actualiza una respuesta EMeT por su ID.
 */
export const updateEmetAnswerById = async (id, data, token) => {
	const response = await certifications.put(`/emet/answers/${id}`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Elimina una pregunta EMeT por su ID.
 */
export const deleteEmetQuestionById = async (id, token) => {
	const response = await certifications.delete(`/emet/questions/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

export const fetchEmetQuestionsReportHeaders = async (token) => {
	const response = await certifications.get(`/emet/questions/report/headers`, {
		headers: getHeaders(token)
	});
	return response.data;
};